import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store.js'
// import Home from "../pages/home/Home"

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [{
      path: '/',
      component: () =>
        import('@/index/index'),
      redirect: "/login",
      children: [{
          path: '/home',
          component: () =>
            import('@/pages/home/Home'),
          meta: {
            index: 0
          }
        },
        {
          path: '/maillist',
          component: () =>
            import('@/pages/maillist/maillist'),
          meta: {
            index: 1
          }
        },
        {
          path: '/workbench',
          component: () =>
            import('@/pages/workbench/workbench'),
          meta: {
            index: 2
          }
        },
        {
          path: '/setup',
          component: () =>
            import('@/pages/setup/setup'),
          redirect: '/personalcenter',
          children: [{
              path: '/personalcenter',
              component: () =>
                import('@/pages/setup/personalCenter')
            },
            {
              path: '/passward',
              component: () =>
                import('@/pages/setup/passward')
            },
            {
              path: '/viewpager',
              component: () =>
                import('@/pages/setup/viewPager')
            },
            {
              path: '/notification',
              component: () =>
                import('@/pages/setup/notification')
            },
            {
              path: '/notificationadd',
              component: () =>
                import('@/pages/setup/notificationAdd')
            },
            {
              path: '/systemsettings',
              component: () =>
                import('@/pages/setup/systemSettings')
            },
            {
              path: '/specialty',
              component: () =>
                import('@/pages/setup/specialty')
            },
            {
              path: '/thirdapply',
              component: () =>
                import('@/pages/setup/thirdApply')
            }
          ],
          meta: {
            index: 3
          }
        },
        // 通知公告详情
        {
          path: '/notificationdetail',
          component: () =>
            import('@/pages/setup/notificationDetail'),
          meta: {
            index: 4
          }
        },
        {
          path: '/maintenanceindex',
          component: () =>
            import('@/pages/maintenancehome/maintenanceindex'),
          meta: {
            index: 5
          }
        },
        {
          path: '/control',
          component: () =>
            import('@/pages/control/control'),
          redirect: '/authorization',
          children: [{
              path: '/authorization',
              component: () =>
                import('@/pages/control/authorization'),
              meta: {
                index: 0
              }
            },
            {
              path: '/system',
              component: () =>
                import('@/pages/control/system'),
              meta: {
                index: 1
              }
            },
            {
              path: '/news',
              component: () =>
                import('@/pages/control/news'),
              meta: {
                index: 2
              }
            },
            {
              path: '/newsadd',
              component: () =>
                import('@/pages/control/newsAdd'),
              meta: {
                index: 3
              }
            }

          ],
          meta: {
            index: 6
          }
        },
        // 新闻资讯详情
        {
          path: '/newsdetail',
          component: () =>
            import('@/pages/control/newsDetail'),
          meta: {
            index: 7
          }
        },
      ],
    },
    //登陆页路由
    {
      path: '/login',
      component: () =>
        import('@/login/login'),
    },
    {
      path: '/register',
      component: () =>
        import('@/login/register'),
    },
    {
      path: '/register_out',
      component: () =>
        import('@/login/register_out'),
    },
    {
      path: '/passwordback',
      component: () =>
        import('@/login/passwordback'),
    },
    {
      path: '/terrace',
      component: () => import('@/pages/car/terrace'),
    }
  ]
})
// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  if (to.path === '/login' || to.path === '/register' || to.path === '/passwordback' || to.path === '/register_out'|| to.path === '/terrace') {
    next();
  } else {
    //头部tonken判断访问请求(权限路由拦截，遍历权限路由数组)
    if (store.getters.Authorization === null || store.getters.Authorization === '') {
      next('/login');
    } else if (store.getters.router.indexOf(to.path) != -1) {
      next();
    }
  }
})



export default router;



// WEBPACK FOOTER //
// ./src/router/index.js